class ProductMediaSlider extends HTMLElement {
    constructor() {
      super();
      this.mainSwiper = null;
      this.thumbSwiper = null;
  
      this.image = this.dataset;
      this.zoomType = this.dataset.zoom;
    }
  
    connectedCallback() {
      this.initSlider();

      if (this.zoomType === "hover") {
        this.enableImageZoom();
      }

      // The section is re-rendered server-side on every variant change
      // (see product-info.js), and product-media-gallery-slider.liquid puts
      // the newly selected variant's media first in that fresh markup. So on
      // variant change we just swap in the fresh slide content and let a
      // freshly-initialized Swiper default to slide 0 — no manual
      // slideTo()/media-id matching needed.
      this._variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { html, variant } }) => {
        this.updateSlides(html);
      });
    }

    disconnectedCallback() {
      this._variantChangeUnsubscriber?.();
    }

    updateSlides(html) {
      const newSlider = html.querySelector('product-media-slider');
      if (!newSlider) return;

      const currentMainWrapper = this.querySelector('.product-media-main-swiper .swiper-wrapper');
      const newMainWrapper = newSlider.querySelector('.product-media-main-swiper .swiper-wrapper');
      const currentThumbWrapper = this.querySelector('.product-media-thumb-swiper .swiper-wrapper');
      const newThumbWrapper = newSlider.querySelector('.product-media-thumb-swiper .swiper-wrapper');

      if (!currentMainWrapper || !newMainWrapper) return;
      // Skip the rebuild if the visible media set hasn't actually changed
      // (e.g. switching an option that doesn't affect the image) — avoids
      // needlessly destroying/reinitializing Swiper on every variant click.
      if (currentMainWrapper.innerHTML === newMainWrapper.innerHTML) return;

      this.mainSwiper?.destroy(true, true);
      this.thumbSwiper?.destroy(true, true);

      currentMainWrapper.innerHTML = newMainWrapper.innerHTML;
      if (currentThumbWrapper && newThumbWrapper) {
        currentThumbWrapper.innerHTML = newThumbWrapper.innerHTML;
      }

      if (this.zoomType === "hover") {
        this.enableImageZoom();
      }

      this.initSlider();
    }


    initSlider() {
      
      this.thumbSwiper = new Swiper(
        this.querySelector(".product-media-thumb-swiper"),
        {
          slidesPerView: 6,
          spaceBetween: 8,
          watchSlidesProgress: true,
          freeMode: true,
          direction: "horizontal",
          breakpoints: {
            0:    { slidesPerView: 5,spaceBetween: 5 },
            640:    { slidesPerView: 6,spaceBetween: 5 },
            768:  { slidesPerView: 4 },
            990:  { slidesPerView: 5 },
            1280: { slidesPerView: 5 },
            1440: { slidesPerView: 6 }
          },
          navigation: {
            nextEl: this.querySelector(".product-hero-next-button"),
            prevEl: this.querySelector(".product-hero-prev-button"),
          }
        }
      );
  
      this.mainSwiper = new Swiper(
        this.querySelector(".product-media-main-swiper"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          effect: "slide",
          thumbs: { swiper: this.thumbSwiper },
        }
      );
    }
  
    enableImageZoom() {
      if (this.dataset.zoom !== "hover") return;
      this.querySelectorAll(".product-media-image").forEach((img) => {

        img.addEventListener("click", (e) => {

          const existing = img.parentElement.querySelector(".product-image-zoom");

          if (existing) {
            existing.remove();
            return;
          }

          const zoom = document.createElement("div");
          zoom.className = "product-image-zoom";

          const zoomLevel = 1;

          zoom.style.backgroundImage = `url('${img.currentSrc || img.src}')`;
          zoom.style.backgroundSize = "150%";

          img.parentElement.appendChild(zoom);

          this.moveZoom(img, zoom, e);

          zoom.addEventListener("mousemove", (event) => {
            this.moveZoom(img, zoom, event);
          });

          zoom.addEventListener("click", () => {
            zoom.remove();
          });

        });
        img.parentElement.addEventListener("mouseleave", () => {
          const zoom = img.parentElement.querySelector(".product-image-zoom");
          if (zoom) zoom.remove();
        });

      });
    }

    moveZoom(img, zoom, e) {

      const rect = img.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;

      zoom.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }
  }
  
  customElements.define("product-media-slider", ProductMediaSlider);